import "core-js/modules/es.array.sort.js";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/library/hooks/address/usePrefetchAddresses.ts
import { useQueryClient } from "@tanstack/react-query";

// src/library/http-clients/AddressHttpClient.ts
import { configurationProvider, implementationProvider } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor } from "@printdeal/authentication";
import axios from "axios";
var AddressHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider.getValue("ADDRESS_API_BASE_URL");
      this.httpClient = axios.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor);
      this.httpClient.interceptors.request.use(config => {
        const updatedConfig = config;
        updatedConfig.headers["x-trace-id"] = implementationProvider.sentryHelper.getDebugId();
        return updatedConfig;
      });
    }
    return this.httpClient;
  }
  createAddress(data) {
    return __async(this, null, function* () {
      return this.client.post("/v1/customer-addresses", data);
    });
  }
  getAddress(addressId) {
    return __async(this, null, function* () {
      return this.client.get("/v1/customer-addresses/".concat(addressId));
    });
  }
  getAddresses() {
    return __async(this, null, function* () {
      return this.client.get("/v1/customer-addresses");
    });
  }
  updateAddress(addressId, data) {
    return __async(this, null, function* () {
      return this.client.patch("/v1/customer-addresses/".concat(addressId), data);
    });
  }
  deleteAddress(addressId) {
    return __async(this, null, function* () {
      return this.client.delete("/v1/customer-addresses/".concat(addressId));
    });
  }
  autocomplete(params) {
    return __async(this, null, function* () {
      return this.client.get("/v1/address-checks/autocomplete", {
        params
      });
    });
  }
};
var addressHttpClient = new AddressHttpClient();
var AddressHttpClient_default = addressHttpClient;

// src/library/hooks/address/usePrefetchAddresses.ts
function usePrefetchAddresses() {
  return __async(this, null, function* () {
    const queryClient = useQueryClient();
    yield queryClient.prefetchQuery({
      queryKey: ["addresses"],
      queryFn: () => __async(null, null, function* () {
        const {
          data
        } = yield AddressHttpClient_default.getAddresses();
        data.addresses.forEach(item => {
          queryClient.setQueryData(["address", item.address.id], item);
        });
        return data;
      })
    });
  });
}

// src/library/views/AddressListView.tsx
import { Alert as Alert2, Button as Button2, Grid, ScrollIntoView as ScrollIntoView2, scrollIntoView, Spinner } from "@printdeal/ui-library";
import { useEffect as useEffect2, useRef, useState as useState2 } from "react";
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import clsx from "clsx";

// src/library/components/design-system/ErrorAlert.tsx
import { FormattedMessage } from "react-intl";
import useDeepCompareEffect from "use-deep-compare-effect";
import { implementationProvider as implementationProvider2 } from "@printdeal/configuration";
import { Alert, ScrollIntoView } from "@printdeal/ui-library";
import { jsx, jsxs } from "react/jsx-runtime";
var ErrorAlert = _ref => {
  let {
    children,
    scrollIntoView: scrollIntoView2 = true,
    className,
    sentryException
  } = _ref;
  useDeepCompareEffect(() => {
    if (sentryException) {
      if (Array.isArray(sentryException)) {
        sentryException.forEach(exception => {
          implementationProvider2.sentryHelper.exception(exception);
        });
      } else {
        implementationProvider2.sentryHelper.exception(sentryException);
      }
    }
  }, [
  // Use {} as fallback value so that useDeepCompareEffect will not crash on a null value.
  sentryException || {}]);
  return /* @__PURE__ */jsxs(ScrollIntoView, {
    scrollIntoView: scrollIntoView2,
    children: [/* @__PURE__ */jsx(Alert, {
      variant: "error",
      className: "".concat(className, " pd:mb-3"),
      children: children || /* @__PURE__ */jsx(FormattedMessage, {
        id: "checkout.generic.error",
        defaultMessage: "An error occurred."
      })
    }), /* @__PURE__ */jsx(implementationProvider2.customerCareComponent, {
      showDebugId: Boolean(sentryException)
    })]
  });
};
var ErrorAlert_default = ErrorAlert;

// src/library/components/list-related/EmptySearchResult.tsx
import { Button, Empty } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage2, useIntl } from "react-intl";
import { jsx as jsx2 } from "react/jsx-runtime";
var EmptySearchResult = _ref2 => {
  let {
    searchTerm,
    setSearchTerm
  } = _ref2;
  const intl = useIntl();
  return /* @__PURE__ */jsx2(Empty, {
    icon: "search",
    title: intl.formatMessage({
      id: "address.search.noAddressesFound",
      defaultMessage: "No addresses found"
    }),
    description: searchTerm ? /* @__PURE__ */jsx2(FormattedMessage2, {
      id: "address.search.noAddressesFoundForSearchTerm",
      defaultMessage: "No addresses found for the search term {searchTerm}.",
      values: {
        searchTerm: /* @__PURE__ */jsx2("span", {
          "data-hj-suppress": true,
          children: "\"".concat(searchTerm, "\"")
        })
      }
    }) : /* @__PURE__ */jsx2(FormattedMessage2, {
      id: "address.search.noAddressesFoundInAddressbook",
      defaultMessage: "No addresses found in your address book"
    }),
    action: searchTerm && /* @__PURE__ */jsx2(Button, {
      onClick: () => setSearchTerm(""),
      children: /* @__PURE__ */jsx2(FormattedMessage2, {
        id: "address.search.clearSearchTerm",
        defaultMessage: "Clear search term"
      })
    })
  });
};
var EmptySearchResult_default = EmptySearchResult;

// src/library/components/list-related/ListPagination.tsx
import { FormattedMessage as FormattedMessage3, useIntl as useIntl2 } from "react-intl";
import { Pagination } from "@printdeal/ui-library";
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ListPagination = _ref3 => {
  let {
    itemsTotal,
    itemsPerPage,
    activePage,
    setActivePage
  } = _ref3;
  const intl = useIntl2();
  return itemsTotal > itemsPerPage && /* @__PURE__ */jsx3("div", {
    className: "pd:flex pd:justify-center",
    children: /* @__PURE__ */jsx3(Pagination, {
      total: itemsTotal,
      perPage: itemsPerPage,
      siblingPages: 2,
      currentPage: activePage,
      "aria-label": intl.formatMessage({
        id: "general.pagination.label",
        defaultMessage: "Pagination"
      }),
      children: _ref4 => {
        let {
          pages
        } = _ref4;
        return /* @__PURE__ */jsxs2(Fragment, {
          children: [/* @__PURE__ */jsx3(Pagination.Button, {
            as: "button",
            variant: "prev",
            onClick: pageNumber => setActivePage(pageNumber),
            children: /* @__PURE__ */jsx3(FormattedMessage3, {
              id: "general.pagination.button.previous",
              defaultMessage: "Previous"
            })
          }), /* @__PURE__ */jsx3(Pagination.Items, {
            children: pages.map(pageNumber => /* @__PURE__ */jsx3(Pagination.Item, {
              as: "button",
              onClick: () => setActivePage(pageNumber)
            }, pageNumber))
          }), /* @__PURE__ */jsx3(Pagination.Button, {
            as: "button",
            variant: "next",
            onClick: pageNumber => setActivePage(pageNumber),
            children: /* @__PURE__ */jsx3(FormattedMessage3, {
              id: "general.pagination.button.Next",
              defaultMessage: "Next"
            })
          })]
        });
      }
    })
  });
};
var ListPagination_default = ListPagination;

// src/library/components/list-related/SearchField.tsx
import { TextField } from "@printdeal/ui-library";
import { useIntl as useIntl3 } from "react-intl";
import { jsx as jsx4 } from "react/jsx-runtime";
var SearchField = _ref5 => {
  let {
    searchTerm,
    setSearchTerm,
    disabled
  } = _ref5;
  const intl = useIntl3();
  return /* @__PURE__ */jsx4(TextField, {
    id: "address-search-field",
    name: "address-search-field",
    label: intl.formatMessage({
      id: "address.search.label",
      defaultMessage: "Search"
    }),
    placeholder: intl.formatMessage({
      id: "address.search.placeholder",
      defaultMessage: "For example: Dorpsstraat 11"
    }),
    iconAfter: "search",
    className: "pd:w-full",
    value: searchTerm,
    onChange: event => setSearchTerm(event.target.value),
    disabled
  });
};
var SearchField_default = SearchField;

// src/library/queries/address/useGetAddressesQuery.ts
import { useQuery } from "@tanstack/react-query";
function useGetAddressesQuery() {
  return useQuery({
    queryKey: ["addresses"],
    queryFn: () => __async(null, null, function* () {
      const {
        data
      } = yield AddressHttpClient_default.getAddresses();
      return data;
    })
  });
}

// src/library/hooks/address/useFilteredSortedAndPaginatedAddresses.ts
import { useEffect, useMemo, useState } from "react";

// src/library/hooks/address/useSortingOptions.ts
import { useIntl as useIntl4 } from "react-intl";
function useSortingOptions() {
  const intl = useIntl4();
  return {
    default: {
      label: intl.formatMessage({
        id: "address.sorting.none",
        defaultMessage: "None"
      }),
      sortingFunction: () => 0
    },
    az: {
      label: intl.formatMessage({
        id: "address.sorting.az",
        defaultMessage: "A-Z"
      }),
      sortingFunction: (addressA, addressB) => {
        const itemA = Object.entries(addressA).filter(_ref6 => {
          let [key] = _ref6;
          return key !== "id";
        }).map(_ref7 => {
          let [, value] = _ref7;
          return value;
        }).join(" ").toLowerCase();
        const itemB = Object.entries(addressB).filter(_ref8 => {
          let [key] = _ref8;
          return key !== "id";
        }).map(_ref9 => {
          let [, value] = _ref9;
          return value;
        }).join(" ").toLowerCase();
        return itemA.localeCompare(itemB);
      }
    },
    za: {
      label: intl.formatMessage({
        id: "address.sorting.za",
        defaultMessage: "Z-A"
      }),
      sortingFunction: (addressA, addressB) => {
        const itemA = Object.entries(addressA).filter(_ref10 => {
          let [key] = _ref10;
          return key !== "id";
        }).map(_ref11 => {
          let [, value] = _ref11;
          return value;
        }).join(" ").toLowerCase();
        const itemB = Object.entries(addressB).filter(_ref12 => {
          let [key] = _ref12;
          return key !== "id";
        }).map(_ref13 => {
          let [, value] = _ref13;
          return value;
        }).join(" ").toLowerCase();
        return itemB.localeCompare(itemA);
      }
    }
  };
}

// src/library/hooks/address/useFilteredSortedAndPaginatedAddresses.ts
function useFilteredSortedAndPaginatedAddresses(_ref14) {
  let {
    searchTerm,
    initialPage,
    itemsPerPage,
    filteredByCountry,
    sortingOption = "default"
  } = _ref14;
  var _a;
  const addressesQuery = useGetAddressesQuery();
  const sortingOptions = useSortingOptions();
  const {
    sortingFunction
  } = sortingOptions[sortingOption];
  const [activePage, setActivePage] = useState(initialPage);
  const addresses = useMemo(() => {
    var _a2;
    return ((_a2 = addressesQuery.data) == null ? void 0 : _a2.addresses) || [];
  }, [(_a = addressesQuery.data) == null ? void 0 : _a.addresses]);
  const filteredAddresses = useMemo(() => {
    const terms = searchTerm.split(/\s+/).reduce((accumulator, term) => {
      if (term) {
        accumulator.push(term.toLowerCase());
      }
      return accumulator;
    }, []);
    return addresses.filter(item => {
      const values = Object.values(item.address).filter(value => typeof value === "string");
      const matchesSearchTerm = terms.every(term => values.some(value => value.toLowerCase().includes(term)));
      const matchesCountry = filteredByCountry ? item.address.country.toLowerCase() === filteredByCountry.toLowerCase() : true;
      return matchesSearchTerm && matchesCountry;
    });
  }, [addresses, filteredByCountry, searchTerm]);
  const sortedAddresses = useMemo(() => {
    const sorted = [...filteredAddresses];
    return sorted.sort((a, b) => sortingFunction(a.address, b.address));
  }, [filteredAddresses, sortingFunction]);
  const paginatedAddresses = useMemo(() => {
    const startIdx = (activePage - 1) * itemsPerPage;
    return sortedAddresses.slice(startIdx, startIdx + itemsPerPage);
  }, [sortedAddresses, activePage, itemsPerPage]);
  useEffect(() => {
    if (activePage > 1 && paginatedAddresses.length === 0) {
      setActivePage(1);
    }
  }, [activePage, paginatedAddresses]);
  return {
    paginatedAddresses,
    addresses: sortedAddresses,
    itemsTotal: filteredAddresses.length,
    activePage,
    setActivePage
  };
}

// src/library/components/list-related/SortingField.tsx
import { SelectField } from "@printdeal/ui-library";
import { useIntl as useIntl5 } from "react-intl";
import { jsx as jsx5 } from "react/jsx-runtime";
var SortingField = _ref15 => {
  let {
    selectedSortingOption,
    setSelectedSortingOption,
    disabled
  } = _ref15;
  const intl = useIntl5();
  const sortingOptions = useSortingOptions();
  return /* @__PURE__ */jsx5(SelectField, {
    id: "address-list-sorting",
    name: "address-list-sorting",
    value: selectedSortingOption,
    label: intl.formatMessage({
      id: "address.sorting.label",
      defaultMessage: "Sort"
    }),
    onChange: event => setSelectedSortingOption(event.target.value),
    disabled,
    children: Object.keys(sortingOptions).map(key => /* @__PURE__ */jsx5(SelectField.Option, {
      value: key,
      children: sortingOptions[key].label
    }, key))
  });
};
var SortingField_default = SortingField;

// src/library/views/AddressListView.tsx
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var AddressListView = _ref16 => {
  let {
    showSuccessAlertForCreatedAddressId,
    showSuccessAlertForUpdatedAddressId,
    renderAddressPanel,
    alert,
    filterByCountry,
    className
  } = _ref16;
  const addressesQuery = useGetAddressesQuery();
  const [searchTerm, setSearchTerm] = useState2("");
  const [selectedSortingOption, setSelectedSortingOption] = useState2("default");
  const [userInitiatedPageChange, setUserInitiatedPageChange] = useState2(false);
  const [focusedAddressId, setFocusedAddressId] = useState2();
  const ref3 = useRef(null);
  const initialPage = 1;
  const itemsPerPage = 8;
  const {
    paginatedAddresses,
    addresses,
    itemsTotal,
    activePage,
    setActivePage
  } = useFilteredSortedAndPaginatedAddresses({
    searchTerm,
    initialPage,
    itemsPerPage,
    filteredByCountry: filterByCountry,
    sortingOption: selectedSortingOption
  });
  useEffect2(() => {
    if (userInitiatedPageChange && ref3.current) {
      scrollIntoView(ref3.current, {
        behavior: "smooth",
        block: "start"
      });
      setUserInitiatedPageChange(false);
    }
  }, [userInitiatedPageChange]);
  return /* @__PURE__ */jsxs3("div", {
    ref: ref3,
    className: clsx("pd:flex pd:flex-col pd:gap-4", className),
    children: [/* @__PURE__ */jsxs3(Grid, {
      className: "pd:grid-cols-2 pd:gap-4 pd:md:grid-cols-3",
      children: [/* @__PURE__ */jsx6(Grid.Item, {
        className: "pd:col-span-2",
        children: /* @__PURE__ */jsx6(SearchField_default, {
          searchTerm,
          setSearchTerm,
          disabled: Boolean(addressesQuery.isLoading || addressesQuery.isError)
        })
      }), /* @__PURE__ */jsx6(Grid.Item, {
        className: "pd:col-span-2 pd:md:col-span-1",
        children: /* @__PURE__ */jsx6(SortingField_default, {
          selectedSortingOption,
          setSelectedSortingOption,
          disabled: Boolean(addressesQuery.isLoading || addressesQuery.isError)
        })
      })]
    }), alert, Boolean(showSuccessAlertForCreatedAddressId || showSuccessAlertForUpdatedAddressId) && /* @__PURE__ */jsx6(ScrollIntoView2, {
      children: /* @__PURE__ */jsx6(Alert2, {
        variant: "success",
        children: /* @__PURE__ */jsxs3("div", {
          className: "pd:flex pd:flex-col pd:gap-4",
          children: [/* @__PURE__ */jsx6("p", {
            children: showSuccessAlertForCreatedAddressId ? /* @__PURE__ */jsx6(FormattedMessage4, {
              id: "address.addressCreatedSuccessfully",
              defaultMessage: "Your address has been created successfully."
            }) : /* @__PURE__ */jsx6(FormattedMessage4, {
              id: "address.addressUpdatedSuccessFully",
              defaultMessage: "Your address has been updated successfully."
            })
          }), /* @__PURE__ */jsx6(Button2, {
            className: "pd:self-start",
            iconBefore: "chevron-right",
            variant: "secondary",
            onClick: () => {
              const addressId = showSuccessAlertForCreatedAddressId != null ? showSuccessAlertForCreatedAddressId : showSuccessAlertForUpdatedAddressId;
              const addressIndex = addresses.findIndex(address => address.address.id === addressId);
              if (addressIndex !== -1) {
                const targetPage = Math.floor(addressIndex / itemsPerPage) + 1;
                setActivePage(targetPage);
              }
              setFocusedAddressId(addressId);
            },
            children: /* @__PURE__ */jsx6(FormattedMessage4, {
              id: "address.button.jumpToAddress",
              defaultMessage: "Jump to address"
            })
          })]
        })
      })
    }), addressesQuery.isLoading || addressesQuery.isError ? /* @__PURE__ */jsxs3(Fragment2, {
      children: [addressesQuery.isLoading && /* @__PURE__ */jsx6("div", {
        className: "pd:flex pd:grow pd:items-center pd:justify-center",
        children: /* @__PURE__ */jsx6(Spinner, {})
      }), addressesQuery.isError && /* @__PURE__ */jsx6(ErrorAlert_default, {
        sentryException: {
          e: addressesQuery.error,
          tags: {
            fileLocation: "AddressListView.tsx",
            featureFunction: "addressesQuery"
          },
          fingerPrint: ["address-frontend", "address-list-view", "addresses-query"]
        },
        children: /* @__PURE__ */jsx6(FormattedMessage4, {
          id: "address.error.errorWhileLoadingAddresses",
          defaultMessage: "An error occurred while loading your addresses."
        })
      })]
    }) : /* @__PURE__ */jsxs3(Fragment2, {
      children: [Boolean(!paginatedAddresses.length) && /* @__PURE__ */jsx6(EmptySearchResult_default, {
        searchTerm,
        setSearchTerm
      }), paginatedAddresses.map(data => /* @__PURE__ */jsx6(ScrollIntoView2, {
        scrollIntoView: focusedAddressId === data.address.id,
        scrollBehavior: "smooth",
        scrollBlock: "center",
        children: renderAddressPanel(data, focusedAddressId)
      }, data.address.id)), /* @__PURE__ */jsx6(ListPagination_default, {
        itemsTotal,
        itemsPerPage,
        activePage,
        setActivePage: pageNumber => {
          setActivePage(pageNumber);
          setFocusedAddressId(void 0);
          setUserInitiatedPageChange(true);
        }
      })]
    })]
  });
};
var AddressListView_default = AddressListView;

// src/library/queries/address/useGetAddressQuery.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
function useGetAddressQuery(_ref17) {
  let {
    addressId
  } = _ref17;
  return useQuery2({
    queryKey: ["address", addressId],
    queryFn: () => __async(null, null, function* () {
      if (!addressId) {
        throw new Error("addressId is required to fetch address");
      }
      const {
        data
      } = yield AddressHttpClient_default.getAddress(addressId);
      return data;
    }),
    enabled: Boolean(addressId)
  });
}

// src/library/components/form/AddressFormSubmitButton.tsx
import { Button as Button3 } from "@printdeal/ui-library";
import { useIsMutating } from "@tanstack/react-query";
import { FormattedMessage as FormattedMessage5 } from "react-intl";
import { jsx as jsx7 } from "react/jsx-runtime";
var AddressFormSubmitButton = () => {
  const isCreatingAddress = useIsMutating({
    mutationKey: ["createAddress"],
    status: "pending"
  });
  const isUpdatingAddress = useIsMutating({
    mutationKey: ["updateAddress"],
    status: "pending"
  });
  return /* @__PURE__ */jsx7(Button3, {
    form: "addressform",
    type: "submit",
    isLoading: Boolean(isCreatingAddress || isUpdatingAddress),
    children: /* @__PURE__ */jsx7(FormattedMessage5, {
      id: "checkout.saveAddress",
      defaultMessage: "Save address"
    })
  });
};
var AddressFormSubmitButton_default = AddressFormSubmitButton;

// src/library/components/form/AddressFormWrapper.tsx
import { FormProvider, useForm } from "react-hook-form";
import { configurationProvider as configurationProvider4 } from "@printdeal/configuration";
import { useEffect as useEffect4 } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

// src/library/hooks/form/useAddressValidationSchema.ts
import * as yup2 from "yup";
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";

// src/library/validation-schemas/address-schema.ts
import * as yup from "yup";
import parsePhoneNumberFromString from "libphonenumber-js";

// src/library/http-clients/VatValidationHttpClient.ts
import { configurationProvider as configurationProvider2 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor2 } from "@printdeal/authentication";
import axios2 from "axios";
var VatValidationHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider2.getValue("VAT_VALIDATION_API_BASE_URL");
      this.httpClient = axios2.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor2);
    }
    return this.httpClient;
  }
  validate(data) {
    return __async(this, null, function* () {
      return this.client.post("/vat-validation", data);
    });
  }
};
var vatValidationHttpClient = new VatValidationHttpClient();
var VatValidationHttpClient_default = vatValidationHttpClient;

// src/library/validation-schemas/address-schema.ts
var disallowedCharactersTest = disallowedCharacters => (value, context) => {
  const foundDisallowedCharacters = disallowedCharacters.split("").filter(character => value == null ? void 0 : value.includes(character));
  if (foundDisallowedCharacters.length > 0) {
    return context.createError({
      message: "".concat(context.path, " must not contain the following characters: ").concat(foundDisallowedCharacters.join(", "))
    });
  }
  return true;
};
var firstNameSchema = () => yup.string().trim().required().max(75).test("disallowedCharacters", disallowedCharactersTest("*"));
var lastNameSchema = () => yup.string().trim().required().max(75).test("disallowedCharacters", disallowedCharactersTest("*"));
var emailSchema = _ref18 => {
  let {
    required,
    reference
  } = _ref18;
  return yup.string().trim().max(255).test("disallowedCharacters", disallowedCharactersTest("\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7\xDF\xD8\xF8\xC5\xE5\xC6\xE6\u0153")).test("tldCheck", (value, _ref19) => {
    let {
      path,
      createError
    } = _ref19;
    const tldRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (value && !tldRegex.test(value)) {
      return createError({
        message: "".concat(path, " must include a valid domain extension")
      });
    }
    return true;
  }).email().when([], {
    is: () => reference && Boolean(reference.key) || required !== void 0,
    then: schema => {
      if (reference) {
        return schema.when(reference.key, {
          is: true,
          then: referenceSchema => referenceSchema.required(),
          otherwise: referenceSchema => referenceSchema.notRequired()
        });
      }
      return required ? schema.required() : schema.notRequired();
    }
  });
};
var phoneSchema = reference => yup.string().trim().test("validatePhone", (value, _ref20) => {
  let {
    path,
    createError,
    resolve
  } = _ref20;
  const country = resolve(reference);
  if (!country) {
    return createError({
      message: "".concat(path, " validation went wrong")
    });
  }
  if (value) {
    const parsedPhoneNumber = parsePhoneNumberFromString(value, country);
    if (parsedPhoneNumber && !parsedPhoneNumber.isValid()) {
      return createError({
        message: "".concat(path, " must be a valid phone number")
      });
    }
  }
  return true;
});
var companySchema = () => yup.string().trim().max(255).test("disallowedCharacters", disallowedCharactersTest("*"));
var countrySchema = () => yup.string().trim().required().length(2).uppercase();
var postalCodeSchema = reference => yup.string().trim().required().test("validatePostalCode", (value, _ref21) => {
  let {
    path,
    createError,
    resolve
  } = _ref21;
  const country = resolve(reference);
  if (!country) {
    return createError({
      message: "".concat(path, " validation went wrong")
    });
  }
  const regexPatterns = {
    NL: /^[1-9][0-9]{3}\s?[a-zA-Z]{2}$/,
    DK: /^\d{4}$/,
    DE: /^\d{5}$/,
    FI: /^\d{5}$/,
    FR: /^\d{5}$/,
    LU: /^\d{4}$/,
    AT: /^\d{4}$/,
    ES: /^\d{5}$/,
    GB: /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/,
    SE: /^\d{3} \d{2}$/,
    BE: /^\d{4}$/,
    IT: /^\d{5}$/
  };
  const regex = regexPatterns[country];
  if (!regex.test(value)) {
    return createError({
      message: "".concat(path, " must be a valid ").concat(country, " postal code")
    });
  }
  return true;
});
var streetNumberSchema = reference => yup.string().trim().required().test("validateStreetNumber", (value, _ref22) => {
  let {
    path,
    createError,
    resolve
  } = _ref22;
  const country = resolve(reference);
  if (!country) {
    return createError({
      message: "".concat(path, " validation went wrong")
    });
  }
  if (country === "NL") {
    const regex = /^[0-9]/;
    if (!regex.test(value)) {
      return createError({
        message: "".concat(path, " must be a valid Dutch street number, starting with a digit")
      });
    }
  }
  return true;
});
var addressLineSchema = () => yup.string().trim().max(255);
var streetNameSchema = () => yup.string().trim().required().max(100);
var citySchema = () => yup.string().trim().required().max(100);
var additionalStreetInfoSchema = () => yup.string().trim().max(255);
var defaultBillingAddressSchema = () => yup.boolean();
var defaultShippingAddressSchema = () => yup.boolean();
var vatIdSchema = queryClient => yup.string().trim().test("validateVatId", (value, _ref23) => {
  let {
    path,
    createError
  } = _ref23;
  if (!value) {
    return true;
  }
  const vatId = value;
  const countryCode = value.substring(0, 2);
  return queryClient.fetchQuery({
    queryKey: ["vatValidation", vatId, countryCode],
    queryFn: () => __async(null, null, function* () {
      const {
        data
      } = yield VatValidationHttpClient_default.validate({
        vatId,
        countryCode
      });
      return data;
    }),
    retry: false,
    staleTime: 6e5
  }).then(response => {
    if (response.message && response.message.status === "valid") {
      return true;
    }
    return createError({
      message: "".concat(path, " must be a valid VAT ID")
    });
  }).catch(() => createError({
    message: "Sorry, something went wrong"
  }));
});
var addressSchema = function () {
  let {
    required,
    reference
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return yup.object({
    firstName: firstNameSchema(),
    lastName: lastNameSchema(),
    email: emailSchema({
      required,
      reference
    }),
    phone: phoneSchema(yup.ref("country")),
    company: companySchema(),
    country: countrySchema(),
    postalCode: postalCodeSchema(yup.ref("country")),
    streetNumber: streetNumberSchema(yup.ref("country")),
    streetName: streetNameSchema(),
    city: citySchema(),
    additionalStreetInfo: additionalStreetInfoSchema()
  });
};

// src/library/hooks/form/useAddressValidationSchema.ts
function useAddressValidationSchema() {
  const queryClient = useQueryClient2();
  return addressSchema({
    reference: yup2.ref("defaultBillingAddress")
  }).shape({
    vatId: vatIdSchema(queryClient),
    addressLine: addressLineSchema(),
    defaultBillingAddress: defaultBillingAddressSchema(),
    defaultShippingAddress: defaultShippingAddressSchema()
  });
}

// src/library/components/form/AddressForm.tsx
import { useFormContext as useFormContext9, useWatch as useWatch2 } from "react-hook-form";
import { configurationProvider as configurationProvider3 } from "@printdeal/configuration";
import { useState as useState5 } from "react";
import { useIntl as useIntl7 } from "react-intl";

// src/library/components/form/fields/AddressTextField.tsx
import { TextField as TextField2 } from "@printdeal/ui-library";
import { useFormContext as useFormContext3 } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

// src/library/hooks/address/useTranslatedAddressYupErrorMessage.ts
import { useCallback } from "react";
import { defineMessages as defineMessages2, useIntl as useIntl6 } from "react-intl";

// src/library/translations/fields.ts
import { defineMessages } from "react-intl";
var fieldNames = defineMessages({
  firstName: {
    id: "address.form.label.firstName",
    defaultMessage: "First name"
  },
  lastName: {
    id: "address.form.label.lastName",
    defaultMessage: "Last name"
  },
  email: {
    id: "address.form.label.email",
    defaultMessage: "Email address"
  },
  phone: {
    id: "address.form.label.phone",
    defaultMessage: "Phone number"
  },
  company: {
    id: "address.form.label.company",
    defaultMessage: "Company name"
  },
  vatId: {
    id: "address.form.label.vatId",
    defaultMessage: "Vat ID"
  },
  country: {
    id: "address.form.label.country",
    defaultMessage: "Country"
  },
  postalCode: {
    id: "address.form.label.postalCode",
    defaultMessage: "Postal code"
  },
  streetNumber: {
    id: "address.form.label.streetNumber",
    defaultMessage: "Street number and addition"
  },
  addressLine: {
    id: "address.form.label.addressLine",
    defaultMessage: "Address line"
  },
  streetName: {
    id: "address.form.label.streetName",
    defaultMessage: "Street name"
  },
  city: {
    id: "address.form.label.city",
    defaultMessage: "City"
  },
  additionalStreetInfo: {
    id: "address.form.label.additionalStreetInfo",
    defaultMessage: "Additional street information"
  }
});
var fields_default = fieldNames;

// src/library/hooks/address/useTranslatedAddressYupErrorMessage.ts
var validationMessages = defineMessages2({
  "{field} is a required field": {
    id: "address.form.validationMessage.required",
    defaultMessage: "{field} is a required field"
  },
  "{field} must be at most {max} characters": {
    id: "address.form.validationMessage.max",
    defaultMessage: "{field} must be at most {max} characters"
  },
  "{field} must not be one of the following values: {disallowedValues}": {
    id: "address.form.validationMessage.notOneOf",
    defaultMessage: "{field} must not be one of the following values: {disallowedValues}"
  },
  "{field} must be a valid email": {
    id: "address.form.validationMessage.email",
    defaultMessage: "{field} must be a valid email"
  },
  "{field} must not contain the following characters: {disallowedCharacters}": {
    id: "address.form.validationMessage.disallowedCharacters",
    defaultMessage: "{field} must not contain the following characters: {disallowedCharacters}"
  },
  "{field} must be a valid phone number": {
    id: "address.form.validationMessage.phone",
    defaultMessage: "{field} must be a valid phone number"
  },
  "{field} must be a valid VAT ID": {
    id: "address.form.validationMessage.vatId",
    defaultMessage: "{field} must be a valid VAT ID"
  },
  "{field} must be exactly {length} characters": {
    id: "address.form.validationMessage.length",
    defaultMessage: "{field} must be exactly {length} characters"
  },
  "{field} must be a valid NL postal code": {
    id: "address.form.validationMessage.postalCodeForNL",
    defaultMessage: "{field} must be a valid Dutch postal code (4 digits + 2 letters)"
  },
  "{field} must be a valid DK postal code": {
    id: "address.form.validationMessage.postalCodeForDK",
    defaultMessage: "{field} must be a valid Danish postal code (4 digits)"
  },
  "{field} must be a valid DE postal code": {
    id: "address.form.validationMessage.postalCodeForDE",
    defaultMessage: "{field} must be a valid German postal code (5 digits)"
  },
  "{field} must be a valid DI postal code": {
    id: "address.form.validationMessage.postalCodeForFI",
    defaultMessage: "{field} must be a valid Finnish postal code (5 digits)"
  },
  "{field} must be a valid FR postal code": {
    id: "address.form.validationMessage.postalCodeForFR",
    defaultMessage: "{field} must be a valid French postal code (5 digits)"
  },
  "{field} must be a valid LU postal code": {
    id: "address.form.validationMessage.postalCodeForLU",
    defaultMessage: "{field} must be a valid Luxembourg postal code (4 digits)"
  },
  "{field} must be a valid AT postal code": {
    id: "address.form.validationMessage.postalCodeForAT",
    defaultMessage: "{field} must be a valid Austrian postal code (4 digits)"
  },
  "{field} must be a valid ES postal code": {
    id: "address.form.validationMessage.postalCodeForES",
    defaultMessage: "{field} must be a valid Spanish postal code (5 digits)"
  },
  "{field} must be a valid GB postal code": {
    id: "address.form.validationMessage.postalCodeForGB",
    defaultMessage: "{field} must be a valid UK postal code (format: A9 9AA or AA9A 9AA)"
  },
  "{field} must be a valid SE postal code": {
    id: "address.form.validationMessage.postalCodeForSE",
    defaultMessage: "{field} must be a valid Swedish postal code (format: 123 45)"
  },
  "{field} must be a valid BE postal code": {
    id: "address.form.validationMessage.postalCodeForBE",
    defaultMessage: "{field} must be a valid Belgian postal code (4 digits)"
  },
  "{field} must be a valid IT postal code": {
    id: "address.form.validationMessage.postalCodeForIT",
    defaultMessage: "{field} must be a valid Italian postal code (5 digits)"
  },
  "{field} must be a valid NL street number, starting with a digit": {
    id: "address.form.validationMessage.streetNumberForNL",
    defaultMessage: "{field} must be a valid Dutch street number, starting with a digit"
  },
  "{field} validation went wrong": {
    id: "address.form.validationMessage.genericError",
    defaultMessage: "{field} validation went wrong, please try again or contact support"
  }
});
function useTranslatedAddressYupErrorMessage(_ref24) {
  let {
    fieldName,
    errorMessage
  } = _ref24;
  const intl = useIntl6();
  const getTranslationInfoFromYupErrorMessage = useCallback(yupErrorMessage => {
    const regExpPerValidator = {
      max: /^(\{field} must be at most) (.*) (characters)$/,
      notOneOf: /^(\{field} must not be one of the following values:) (.*)$/,
      disallowedCharacters: /^(\{field} must not contain the following characters:) (.*)$/,
      length: /^(\{field} must be exactly) (.*) (characters)$/
    };
    let id2 = yupErrorMessage.replace(/^\S+/, "{field}");
    const values2 = {};
    if (regExpPerValidator.max.test(id2)) {
      values2.max = id2.replace(regExpPerValidator.max, "$2");
      id2 = id2.replace(regExpPerValidator.max, "$1 {max} $3");
    } else if (regExpPerValidator.notOneOf.test(id2)) {
      values2.disallowedValues = id2.replace(regExpPerValidator.notOneOf, "$2");
      id2 = id2.replace(regExpPerValidator.notOneOf, "$1 {disallowedValues}");
    } else if (regExpPerValidator.disallowedCharacters.test(id2)) {
      values2.disallowedCharacters = id2.replace(regExpPerValidator.disallowedCharacters, "$2");
      id2 = id2.replace(regExpPerValidator.disallowedCharacters, "$1 {disallowedCharacters}");
    } else if (regExpPerValidator.length.test(id2)) {
      values2.length = id2.replace(regExpPerValidator.length, "$2");
      id2 = id2.replace(regExpPerValidator.length, "$1 {length} $3");
    }
    return {
      id: id2,
      values: values2
    };
  }, []);
  const {
    id,
    values
  } = getTranslationInfoFromYupErrorMessage(errorMessage);
  if (id in validationMessages) {
    if (fieldName && fieldName in fields_default) {
      return intl.formatMessage(validationMessages[id], __spreadValues({
        field: intl.formatMessage(fields_default[fieldName])
      }, Object.entries(values).reduce((acc, _ref25) => {
        let [key, value] = _ref25;
        if (typeof value === "string") {
          acc[key] = value;
        } else {
          acc[key] = intl.formatMessage(value);
        }
        return acc;
      }, {})));
    }
    return intl.formatMessage({
      id,
      defaultMessage: errorMessage
    }, __spreadValues({
      field: fieldName
    }, Object.entries(values).reduce((acc, _ref26) => {
      let [key, value] = _ref26;
      if (typeof value === "string") {
        acc[key] = value;
      } else {
        acc[key] = intl.formatMessage(value);
      }
      return acc;
    }, {})));
  }
  return errorMessage;
}

// src/library/components/form/AddressValidationMessage.tsx
var AddressValidationMessage = _ref27 => {
  let {
    fieldName,
    errorMessage
  } = _ref27;
  const translatedError = useTranslatedAddressYupErrorMessage({
    fieldName,
    errorMessage
  });
  return translatedError;
};
var AddressValidationMessage_default = AddressValidationMessage;

// src/library/hooks/form/useIsFieldRequired.ts
import { useFormContext } from "react-hook-form";
function useIsFieldRequired(fieldName, formValues) {
  let requiredRetrigger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const addressSchema2 = useAddressValidationSchema();
  const addressForm = useFormContext();
  if (requiredRetrigger.length > 0) {
    addressForm.watch(requiredRetrigger);
  }
  if (fieldName === "email" && formValues.defaultBillingAddress) {
    return true;
  }
  if (fieldName in addressSchema2.fields) {
    const field = addressSchema2.fields[fieldName].describe();
    return !field.optional;
  }
  return false;
}

// src/library/hooks/form/useValidationStatus.ts
import { useFormContext as useFormContext2 } from "react-hook-form";
function useValidationStatus(fieldName) {
  const {
    getValues,
    formState: {
      errors,
      touchedFields,
      isSubmitted,
      isSubmitting
    }
  } = useFormContext2();
  const error = errors[fieldName];
  const touched = touchedFields[fieldName];
  const value = getValues(fieldName);
  if (isSubmitted || isSubmitting) {
    if (error) {
      return "error";
    }
    if (value) {
      return "success";
    }
    return void 0;
  }
  if (!error) {
    if (touched && Boolean(value)) {
      return "success";
    }
    return void 0;
  }
  return "error";
}

// src/library/components/form/fields/AddressTextField.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var AddressTextField = _ref28 => {
  let {
    fieldName,
    label,
    description,
    icon,
    disabled,
    requiredRetrigger = [],
    onChange
  } = _ref28;
  const {
    register,
    getValues,
    trigger,
    formState: {
      errors
    }
  } = useFormContext3();
  const isRequired = useIsFieldRequired(fieldName, getValues(), requiredRetrigger);
  const validationStatus = useValidationStatus(fieldName);
  return /* @__PURE__ */jsx8(TextField2, __spreadProps(__spreadValues({}, register(fieldName, {
    onChange: event => {
      if (onChange) {
        onChange(event);
      }
    },
    onBlur: () => {
      trigger(fieldName);
    }
  })), {
    id: fieldName,
    name: fieldName,
    label,
    description,
    iconAfter: icon,
    required: isRequired,
    disabled,
    validation: validationStatus,
    validationMessage: errors[fieldName] && /* @__PURE__ */jsx8(ErrorMessage, {
      errors,
      name: fieldName,
      render: _ref29 => {
        let {
          message
        } = _ref29;
        return /* @__PURE__ */jsx8(AddressValidationMessage_default, {
          fieldName,
          errorMessage: message
        });
      }
    })
  }));
};
var AddressTextField_default = AddressTextField;

// src/library/components/form/fields/AddressCheckboxField.tsx
import { CheckboxField } from "@printdeal/ui-library";
import { useFormContext as useFormContext4, Controller } from "react-hook-form";
import { jsx as jsx9 } from "react/jsx-runtime";
var AddressCheckboxField = _ref30 => {
  let {
    fieldName,
    label,
    description
  } = _ref30;
  const {
    control
  } = useFormContext4();
  return /* @__PURE__ */jsx9(Controller, {
    name: fieldName,
    control,
    render: _ref31 => {
      let {
        field: {
          onChange
        },
        formState: {
          defaultValues
        }
      } = _ref31;
      return /* @__PURE__ */jsx9(CheckboxField, {
        id: fieldName,
        name: fieldName,
        label,
        description,
        defaultChecked: Boolean(defaultValues && defaultValues[fieldName]),
        disabled: Boolean(defaultValues && defaultValues[fieldName]),
        onChange: event => onChange(event.target.checked)
      });
    }
  });
};
var AddressCheckboxField_default = AddressCheckboxField;

// src/library/translations/countries.ts
import { defineMessages as defineMessages3 } from "react-intl";
var countries = defineMessages3({
  NL: {
    id: "address.country.nl",
    defaultMessage: "Netherlands"
  },
  DK: {
    id: "address.country.dk",
    defaultMessage: "Denmark"
  },
  DE: {
    id: "address.country.de",
    defaultMessage: "Germany"
  },
  FI: {
    id: "address.country.fi",
    defaultMessage: "Finland"
  },
  FR: {
    id: "address.country.fr",
    defaultMessage: "France"
  },
  LU: {
    id: "address.country.lu",
    defaultMessage: "Luxembourg"
  },
  AT: {
    id: "address.country.at",
    defaultMessage: "Austria"
  },
  ES: {
    id: "address.country.es",
    defaultMessage: "Spain"
  },
  GB: {
    id: "address.country.gb",
    defaultMessage: "United Kingdom"
  },
  SE: {
    id: "address.country.se",
    defaultMessage: "Sweden"
  },
  IE: {
    id: "address.country.ie",
    defaultMessage: "Ireland"
  },
  HU: {
    id: "address.country.hu",
    defaultMessage: "Hungary"
  },
  RO: {
    id: "address.country.ro",
    defaultMessage: "Romania"
  },
  PT: {
    id: "address.country.pt",
    defaultMessage: "Portugal"
  },
  CH: {
    id: "address.country.ch",
    defaultMessage: "Switzerland"
  },
  BE: {
    id: "address.country.be",
    defaultMessage: "Belgium"
  },
  IT: {
    id: "address.country.it",
    defaultMessage: "Italy"
  }
});
var countries_default = countries;

// src/library/translations/postcode-descriptions.ts
import { defineMessages as defineMessages4 } from "react-intl";
var postcodeDescriptions = defineMessages4({
  postalCode: {
    id: "address.form.example.postalCode.default",
    defaultMessage: "For example: 7418 ET"
  },
  postalCodeNL: {
    id: "address.form.example.postalCode.nl",
    defaultMessage: "For example: 7418 ET"
  },
  postalCodeBE: {
    id: "address.form.example.postalCode.be",
    defaultMessage: "For example: 2000"
  },
  postalCodeDE: {
    id: "address.form.example.postalCode.de",
    defaultMessage: "For example: 10115"
  },
  postalCodeFR: {
    id: "address.form.example.postalCode.fr",
    defaultMessage: "For example: 06000"
  },
  postalCodeLU: {
    id: "address.form.example.postalCode.lu",
    defaultMessage: "For example: 1019"
  },
  postalCodeDK: {
    id: "address.form.example.postalCode.dk",
    defaultMessage: "For example: 2200"
  },
  postalCodeAT: {
    id: "address.form.example.postalCode.at",
    defaultMessage: "For example: 2000"
  },
  postalCodeSE: {
    id: "address.form.example.postalCode.se",
    defaultMessage: "For example: 11115"
  },
  postalCodeFI: {
    id: "address.form.example.postalCode.fi",
    defaultMessage: "For example: 00100"
  },
  postalCodeES: {
    id: "address.form.example.postalCode.es",
    defaultMessage: "For example: 01001"
  }
});
var postcode_descriptions_default = postcodeDescriptions;

// src/library/components/form/fields/AddressSelectField.tsx
import { SelectField as SelectField2 } from "@printdeal/ui-library";
import { useFormContext as useFormContext5 } from "react-hook-form";
import { jsx as jsx10 } from "react/jsx-runtime";
var AddressSelectField = _ref32 => {
  let {
    fieldName,
    label,
    description,
    options,
    onChange
  } = _ref32;
  const {
    register
  } = useFormContext5();
  return /* @__PURE__ */jsx10(SelectField2, __spreadProps(__spreadValues({}, register(fieldName, {
    onChange(event) {
      if (onChange) {
        onChange(event);
      }
    }
  })), {
    id: fieldName,
    name: fieldName,
    label,
    description,
    children: options.map(option => /* @__PURE__ */jsx10(SelectField2.Option, {
      value: option.value,
      children: option.label
    }, option.label))
  }));
};
var AddressSelectField_default = AddressSelectField;

// src/library/components/form/autocomplete/AddressAutocomplete.tsx
import { useCallback as useCallback4, useState as useState4 } from "react";
import { useFormContext as useFormContext7, useWatch } from "react-hook-form";

// src/library/helpers/AddressHelper.ts
function mergeStreetNumberAndAddition(streetNumber, addition) {
  const streetNumberString = streetNumber ? streetNumber.toString() : "";
  return "".concat(streetNumberString).concat(addition ? " ".concat(addition) : "");
}
function splitStreetNumberAndAddition(streetNumberAndAddition) {
  const streetNumberWithoutAddition = parseInt(streetNumberAndAddition, 10).toString();
  const streetNumberAddition = streetNumberAndAddition.slice(streetNumberWithoutAddition.length).trim();
  return [streetNumberWithoutAddition, streetNumberAddition];
}

// src/library/hooks/form/useHandleAddressChange.ts
import { useFormContext as useFormContext6 } from "react-hook-form";
import { useCallback as useCallback3, useEffect as useEffect3 } from "react";
import { useDebounceCallback } from "usehooks-ts";

// src/library/hooks/form/useAddressAutocomplete.ts
import { useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import { useCallback as useCallback2 } from "react";
function useAddressAutocomplete() {
  let {
    onFetch,
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const queryClient = useQueryClient3();
  const fetchAutocomplete = useCallback2(_0 => __async(null, [_0], function (_ref33) {
    let {
      country,
      postalCode,
      streetNumber,
      addressLine
    } = _ref33;
    return function* () {
      if (country && postalCode && (streetNumber || addressLine)) {
        if (onFetch) {
          onFetch();
        }
        yield queryClient.fetchQuery({
          queryKey: ["addressAutocomplete", {
            country,
            postalCode,
            streetNumber,
            addressLine
          }],
          queryFn: () => __async(null, null, function* () {
            const {
              data
            } = yield AddressHttpClient_default.autocomplete({
              country,
              postalCode,
              streetNumber,
              addressLine
            });
            return data;
          })
        }).then(data => {
          if (onSuccess) {
            onSuccess(data);
          }
        }).catch(() => {
          if (onError) {
            onError();
          }
        });
      }
    }();
  }), [queryClient, onFetch, onSuccess, onError]);
  return {
    fetchAutocomplete
  };
}

// src/library/hooks/form/useHandleAddressChange.ts
function useHandleAddressChange() {
  let {
    onFetch,
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    watch,
    trigger
  } = useFormContext6();
  const {
    fetchAutocomplete
  } = useAddressAutocomplete({
    onFetch: useCallback3(() => {
      if (onFetch) {
        onFetch();
      }
    }, [onFetch]),
    onSuccess: useCallback3(data => {
      if (onSuccess) {
        onSuccess(data);
      }
    }, [onSuccess]),
    onError: useCallback3(() => {
      if (onError) {
        onError();
      }
    }, [onError])
  });
  const handleAddressChange = useCallback3(_0 => __async(null, [_0], function (_ref34) {
    let {
      country,
      postalCode,
      streetNumber,
      addressLine
    } = _ref34;
    return function* () {
      if (country && postalCode && (streetNumber || addressLine)) {
        const fields = country === "NL" ? ["country", "postalCode", "streetNumber"] : ["country", "postalCode", "addressLine"];
        const isValid = yield trigger(fields);
        if (isValid) {
          yield fetchAutocomplete({
            country,
            postalCode,
            streetNumber,
            addressLine
          });
        }
      }
    }();
  }), [trigger, fetchAutocomplete]);
  const debouncedHandleAddressChange = useDebounceCallback(handleAddressChange, 600);
  useEffect3(() => {
    const subscription = watch((data, _ref35) => {
      let {
        name,
        type
      } = _ref35;
      const fields = ["country", "postalCode", "streetNumber", "addressLine"];
      if (data.country && data.postalCode && (data.streetNumber || data.addressLine) && type === "change" && name && fields.includes(name)) {
        debouncedHandleAddressChange({
          country: data.country,
          postalCode: data.postalCode,
          streetNumber: data.streetNumber,
          addressLine: data.addressLine
        });
      }
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [watch, debouncedHandleAddressChange]);
}

// src/library/components/form/autocomplete/AddressAutocompleteLoading.tsx
import { Spinner as Spinner2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage6 } from "react-intl";
import { jsx as jsx11, jsxs as jsxs4 } from "react/jsx-runtime";
var AddressAutocompleteLoading = () => /* @__PURE__ */jsxs4("div", {
  className: "pd:flex pd:items-center pd:justify-items-start pd:gap-3",
  children: [/* @__PURE__ */jsx11(Spinner2, {
    variant: "dim",
    size: "sm"
  }), /* @__PURE__ */jsx11(FormattedMessage6, {
    id: "address.check.checking",
    defaultMessage: "Checking address ..."
  })]
});
var AddressAutocompleteLoading_default = AddressAutocompleteLoading;

// src/library/components/form/autocomplete/alerts/AddressAutocompleteErrorAlert.tsx
import { Alert as Alert3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage7 } from "react-intl";
import { jsx as jsx12 } from "react/jsx-runtime";
var AddressAutocompleteErrorAlert = _ref36 => {
  let {
    country
  } = _ref36;
  return /* @__PURE__ */jsx12(Alert3, {
    variant: "warning",
    children: country === "NL" ? /* @__PURE__ */jsx12(FormattedMessage7, {
      id: "address.check.notFound",
      defaultMessage: "We could not find an address with the postal code and street number you filled in. Please check whether you filled it in correctly, or manually fill in your street name and city below."
    }) : /* @__PURE__ */jsx12(FormattedMessage7, {
      id: "address.check.notFoundAddressLine",
      defaultMessage: "We could not find an address with the postal code and address line you filled in. Please check whether you filled it in correctly, or manually fill in your street number, street name and city below."
    })
  }, "warning");
};
var AddressAutocompleteErrorAlert_default = AddressAutocompleteErrorAlert;

// src/library/components/form/autocomplete/alerts/AddressAutocompleteDefaultAlert.tsx
import { Alert as Alert4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage8 } from "react-intl";
import { jsx as jsx13 } from "react/jsx-runtime";
var AddressAutocompleteDefaultAlert = _ref37 => {
  let {
    country
  } = _ref37;
  return /* @__PURE__ */jsx13(Alert4, {
    variant: "info",
    children: country === "NL" ? /* @__PURE__ */jsx13(FormattedMessage8, {
      id: "address.check.explanation",
      defaultMessage: "We will autocomplete your address after you fill in your postal code and street number."
    }) : /* @__PURE__ */jsx13(FormattedMessage8, {
      id: "address.check.explanationAddressLine",
      defaultMessage: "We will autocomplete your address after you fill in your postal code and address line."
    })
  }, "info");
};
var AddressAutocompleteDefaultAlert_default = AddressAutocompleteDefaultAlert;

// src/library/components/form/autocomplete/AddressAutocompleteSuggestions.tsx
import { LinkAsButton, Panel } from "@printdeal/ui-library";
import clsx2 from "clsx";
import { useState as useState3 } from "react";
import { FormattedMessage as FormattedMessage9 } from "react-intl";
import { jsx as jsx14, jsxs as jsxs5 } from "react/jsx-runtime";
var AddressAutocompleteSuggestions = _ref38 => {
  let {
    suggestions,
    onSelectSuggestion
  } = _ref38;
  const itemsPerClick = 3;
  const [maxItems, setMaxItems] = useState3(itemsPerClick);
  return /* @__PURE__ */jsxs5(Panel, {
    className: "pd:overflow-hidden pd:p-0",
    children: [suggestions.slice(0, maxItems).map((suggestion, index) => /* @__PURE__ */jsxs5("button", {
      className: clsx2("pd:w-full pd:px-4 pd:py-3 pd:text-left pd:hover:bg-primary-500 pd:hover:text-white pd:focus:bg-primary-500 pd:focus:text-white", {
        "pd:border-t": index > 0
      }),
      type: "button",
      onClick: () => {
        onSelectSuggestion(suggestion);
      },
      "data-hj-suppress": true,
      children: [suggestion.streetName, " ", mergeStreetNumberAndAddition(suggestion.houseNumber, suggestion.houseNumberAddition), ",", " ", suggestion.postalCode, " ", suggestion.cityName]
    }, suggestion.formattedAddress.toString())), suggestions.length > maxItems && /* @__PURE__ */jsx14("div", {
      className: "pd:flex pd:justify-center pd:border-t pd:py-3",
      children: /* @__PURE__ */jsx14(LinkAsButton, {
        className: "pd:text-sm",
        type: "button",
        onClick: () => setMaxItems(maxItems + itemsPerClick),
        children: /* @__PURE__ */jsx14(FormattedMessage9, {
          id: "address.check.showMoreSuggestions",
          defaultMessage: "Show more suggestions"
        })
      })
    })]
  });
};
var AddressAutocompleteSuggestions_default = AddressAutocompleteSuggestions;

// src/library/components/form/autocomplete/alerts/AddressAutocompleteSuccessAlert.tsx
import { Alert as Alert5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage10 } from "react-intl";
import { jsx as jsx15 } from "react/jsx-runtime";
var AddressAutocompleteSuccessAlert = () => /* @__PURE__ */jsx15(Alert5, {
  variant: "success",
  children: /* @__PURE__ */jsx15(FormattedMessage10, {
    id: "address.check.success",
    defaultMessage: "Your address has been autocompleted below."
  })
});
var AddressAutocompleteSuccessAlert_default = AddressAutocompleteSuccessAlert;

// src/library/components/form/autocomplete/AddressAutocomplete.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var AddressAutocomplete = _ref39 => {
  let {
    status,
    setStatus
  } = _ref39;
  const {
    setValue,
    setFocus
  } = useFormContext7();
  const country = useWatch({
    name: "country"
  });
  const [selectedSuggestion, setSelectedSuggestion] = useState4();
  const [suggestions, setSuggestions] = useState4();
  const updateFormValues = useCallback4(suggestion => {
    const streetNumber = mergeStreetNumberAndAddition(suggestion.houseNumber, suggestion.houseNumberAddition);
    setValue("postalCode", suggestion.postalCode, {
      shouldValidate: true,
      shouldTouch: true
    });
    setValue("streetNumber", streetNumber, {
      shouldValidate: true,
      shouldTouch: true
    });
    setValue("streetName", suggestion.streetName, {
      shouldValidate: true,
      shouldTouch: true
    });
    setValue("city", suggestion.cityName, {
      shouldValidate: true,
      shouldTouch: true
    });
    setFocus("additionalStreetInfo");
  }, [setValue, setFocus]);
  useHandleAddressChange({
    onFetch: useCallback4(() => {
      setStatus("loading");
    }, [setStatus]),
    onSuccess: useCallback4(data => {
      setStatus("success");
      if (data.length === 1) {
        const [suggestion] = data;
        setSelectedSuggestion(suggestion);
        setSuggestions(void 0);
        updateFormValues(suggestion);
      } else {
        setSelectedSuggestion(void 0);
        setSuggestions(data);
      }
    }, [setStatus, updateFormValues]),
    onError: useCallback4(() => {
      setStatus("error");
      setSelectedSuggestion(void 0);
      setSuggestions(void 0);
    }, [setStatus])
  });
  if (status === "loading") {
    return /* @__PURE__ */jsx16(AddressAutocompleteLoading_default, {});
  }
  if (status === "error") {
    return /* @__PURE__ */jsx16(AddressAutocompleteErrorAlert_default, {
      country
    });
  }
  if (suggestions && !selectedSuggestion) {
    return /* @__PURE__ */jsx16(AddressAutocompleteSuggestions_default, {
      suggestions,
      onSelectSuggestion: suggestion => {
        setSelectedSuggestion(suggestion);
        setSuggestions(void 0);
        updateFormValues(suggestion);
      }
    });
  }
  if (status === "success" && selectedSuggestion) {
    return /* @__PURE__ */jsx16(AddressAutocompleteSuccessAlert_default, {});
  }
  return /* @__PURE__ */jsx16(AddressAutocompleteDefaultAlert_default, {
    country
  });
};
var AddressAutocomplete_default = AddressAutocomplete;

// src/library/hooks/form/useFormResetFields.ts
import { useCallback as useCallback5 } from "react";
import { useFormContext as useFormContext8 } from "react-hook-form";
function useFormResetFields() {
  const {
    resetField
  } = useFormContext8();
  return useCallback5(fields => {
    fields.forEach(field => {
      resetField(field, {
        defaultValue: ""
      });
    });
  }, [resetField]);
}

// src/library/hooks/form/useScrollToError.ts
import { useCallback as useCallback6 } from "react";
function useScrollToError() {
  return useCallback6(errors => {
    const [errorKey] = Object.keys(errors);
    if (errorKey) {
      const field = errors[errorKey];
      if (field && field.ref instanceof HTMLElement) {
        field.ref.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
        field.ref.focus({
          preventScroll: true
        });
      }
    }
  }, []);
}

// src/library/components/form/AddressForm.tsx
import { Fragment as Fragment3, jsx as jsx17, jsxs as jsxs6 } from "react/jsx-runtime";
var AddressForm = _ref40 => {
  let {
    onSubmit
  } = _ref40;
  const intl = useIntl7();
  const country = useWatch2({
    name: "country"
  });
  const {
    handleSubmit,
    setValue
  } = useFormContext9();
  const resetOnChange = useFormResetFields();
  const scrollToError = useScrollToError();
  const [autocompleteStatus, setAutocompleteStatus] = useState5("default");
  return /* @__PURE__ */jsx17("form", {
    id: "addressform",
    onSubmit: handleSubmit(onSubmit, scrollToError),
    noValidate: true,
    children: /* @__PURE__ */jsxs6("div", {
      className: "pd:flex pd:flex-col pd:gap-4",
      children: [/* @__PURE__ */jsxs6("div", {
        className: "pd:grid pd:grid-cols-1 pd:gap-4 pd:md:grid-cols-2",
        children: [/* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "firstName",
          label: intl.formatMessage(fields_default.firstName)
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "lastName",
          label: intl.formatMessage(fields_default.lastName)
        })]
      }), /* @__PURE__ */jsx17(AddressTextField_default, {
        fieldName: "email",
        label: intl.formatMessage(fields_default.email),
        requiredRetrigger: ["defaultBillingAddress"]
      }), /* @__PURE__ */jsx17(AddressTextField_default, {
        fieldName: "phone",
        label: intl.formatMessage(fields_default.phone),
        description: intl.formatMessage({
          id: "address.form.example.phone",
          defaultMessage: "For example: +31 88 88 55 220"
        })
      }), /* @__PURE__ */jsxs6("div", {
        className: "pd:grid pd:grid-cols-1 pd:gap-4 pd:md:grid-cols-2",
        children: [/* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "company",
          label: intl.formatMessage(fields_default.company)
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "vatId",
          label: intl.formatMessage(fields_default.vatId),
          description: intl.formatMessage({
            id: "address.form.example.vatId",
            defaultMessage: "For example: NL819555514B01"
          }),
          onChange: event => {
            setValue("vatId", event.target.value.replace(/[ .]/g, "").toUpperCase());
          }
        })]
      }), /* @__PURE__ */jsx17(AddressSelectField_default, {
        fieldName: "country",
        label: intl.formatMessage(fields_default.country),
        options: configurationProvider3.getValueAsArray("ADDRESS_COUNTRIES").map(countryCode => ({
          value: countryCode,
          label: intl.formatMessage(countries_default[countryCode]) || countryCode
        })),
        onChange: () => {
          resetOnChange(["postalCode", "addressLine", "streetNumber", "streetName", "city", "additionalStreetInfo"]);
          setAutocompleteStatus("default");
        }
      }), country === "NL" ? /* @__PURE__ */jsxs6("div", {
        className: "pd:grid pd:grid-cols-1 pd:gap-4 pd:md:grid-cols-2",
        children: [/* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "postalCode",
          label: intl.formatMessage(fields_default.postalCode),
          description: "postalCode".concat(country) in postcode_descriptions_default ? intl.formatMessage(postcode_descriptions_default["postalCode".concat(country)]) : void 0,
          onChange: () => {
            resetOnChange(["streetName", "city", "additionalStreetInfo"]);
            setAutocompleteStatus("default");
          }
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "streetNumber",
          label: intl.formatMessage(fields_default.streetNumber),
          description: intl.formatMessage({
            id: "address.form.example.streetNumber",
            defaultMessage: "For example: 4 A"
          }),
          onChange: () => {
            resetOnChange(["streetName", "city", "additionalStreetInfo"]);
            setAutocompleteStatus("default");
          }
        })]
      }) : /* @__PURE__ */jsxs6(Fragment3, {
        children: [/* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "postalCode",
          label: intl.formatMessage(fields_default.postalCode),
          description: "postalCode".concat(country) in postcode_descriptions_default ? intl.formatMessage(postcode_descriptions_default["postalCode".concat(country)]) : void 0,
          onChange: () => {
            resetOnChange(["streetNumber", "streetName", "city", "additionalStreetInfo"]);
            setAutocompleteStatus("default");
          }
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "addressLine",
          label: intl.formatMessage(fields_default.addressLine),
          description: intl.formatMessage({
            id: "address.form.example.addressLine",
            defaultMessage: "For example: Dorpstraat 11"
          }),
          icon: "search",
          onChange: () => {
            resetOnChange(["streetNumber", "streetName", "city", "additionalStreetInfo"]);
            setAutocompleteStatus("default");
          }
        })]
      }), /* @__PURE__ */jsx17(AddressAutocomplete_default, {
        status: autocompleteStatus,
        setStatus: setAutocompleteStatus
      }), country === "NL" ? /* @__PURE__ */jsxs6(Fragment3, {
        children: [/* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "streetName",
          label: intl.formatMessage(fields_default.streetName),
          disabled: Boolean(autocompleteStatus !== "error")
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "city",
          label: intl.formatMessage(fields_default.city),
          disabled: Boolean(autocompleteStatus !== "error")
        })]
      }) : /* @__PURE__ */jsxs6(Fragment3, {
        children: [/* @__PURE__ */jsxs6("div", {
          className: "pd:grid pd:grid-cols-1 pd:gap-4 pd:md:grid-cols-2",
          children: [/* @__PURE__ */jsx17(AddressTextField_default, {
            fieldName: "streetName",
            label: intl.formatMessage(fields_default.streetName),
            disabled: Boolean(autocompleteStatus !== "error")
          }), /* @__PURE__ */jsx17(AddressTextField_default, {
            fieldName: "streetNumber",
            label: intl.formatMessage(fields_default.streetNumber),
            description: intl.formatMessage({
              id: "address.form.example.streetNumber",
              defaultMessage: "For example: 4 A"
            }),
            disabled: Boolean(autocompleteStatus !== "error")
          })]
        }), /* @__PURE__ */jsx17(AddressTextField_default, {
          fieldName: "city",
          label: intl.formatMessage(fields_default.city),
          disabled: Boolean(autocompleteStatus !== "error")
        })]
      }), /* @__PURE__ */jsx17(AddressTextField_default, {
        fieldName: "additionalStreetInfo",
        label: intl.formatMessage(fields_default.additionalStreetInfo),
        description: intl.formatMessage({
          id: "address.form.example.additionalStreetInfo",
          defaultMessage: "For example: Second floor"
        })
      }), /* @__PURE__ */jsx17(AddressCheckboxField_default, {
        fieldName: "defaultBillingAddress",
        label: intl.formatMessage({
          id: "address.form.label.setDefaultBillingAddress",
          defaultMessage: "Set as default billing address for future orders"
        })
      }), /* @__PURE__ */jsx17(AddressCheckboxField_default, {
        fieldName: "defaultShippingAddress",
        label: intl.formatMessage({
          id: "address.form.label.setDefaultShippingAddress",
          defaultMessage: "Set as default shipping address for future orders"
        })
      })]
    })
  });
};
var AddressForm_default = AddressForm;

// src/library/components/form/AddressFormWrapper.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var AddressFormWrapper = _ref41 => {
  let {
    defaultValues,
    onSubmit
  } = _ref41;
  const addressSchema2 = useAddressValidationSchema();
  const form = useForm({
    mode: "onTouched",
    resolver: yupResolver(addressSchema2),
    defaultValues: __spreadValues({
      country: configurationProvider4.getValue("DEFAULT_SHIPPING_COUNTRY")
    }, defaultValues)
  });
  useEffect4(() => {
    if (defaultValues && !form.formState.isSubmitting) {
      const defaultValueKeys = Object.keys(defaultValues);
      defaultValueKeys.forEach(key => {
        const currentFormValue = form.getValues(key);
        const newDefaultValue = defaultValues[key];
        if (currentFormValue !== newDefaultValue) {
          form.setValue(key, newDefaultValue, {
            shouldValidate: false
          });
          form.trigger(key);
        }
      });
    }
  }, [form, defaultValues]);
  return /* @__PURE__ */jsx18(FormProvider, __spreadProps(__spreadValues({}, form), {
    children: /* @__PURE__ */jsx18(AddressForm_default, {
      onSubmit
    })
  }));
};
var AddressFormWrapper_default = AddressFormWrapper;

// src/library/queries/address/useCreateAddressMutation.ts
import { useMutation } from "@tanstack/react-query";
function useCreateAddressMutation() {
  return useMutation({
    mutationKey: ["createAddress"],
    mutationFn: payload => __async(null, null, function* () {
      const {
        data
      } = yield AddressHttpClient_default.createAddress(payload);
      return data;
    })
  });
}

// src/library/views/CreateAddressView.tsx
import { jsx as jsx19 } from "react/jsx-runtime";
var CreateAddressView = _ref42 => {
  let {
    onSubmitSuccess
  } = _ref42;
  const createAddressMutation = useCreateAddressMutation();
  return /* @__PURE__ */jsx19(AddressFormWrapper_default, {
    onSubmit: values => __async(null, null, function* () {
      const data = __spreadValues(__spreadValues({
        address: values
      }, values.defaultBillingAddress && {
        setDefaultBillingAddress: true
      }), values.defaultShippingAddress && {
        setDefaultShippingAddress: true
      });
      yield createAddressMutation.mutateAsync(data).then(address => {
        onSubmitSuccess(address);
      });
    })
  });
};
var CreateAddressView_default = CreateAddressView;

// src/library/components/address/AddressDeleteModal.tsx
import { Button as Button4, Modal } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage11, useIntl as useIntl8 } from "react-intl";
import { useQueryClient as useQueryClient4 } from "@tanstack/react-query";

// src/library/queries/address/useDeleteAddressMutation.ts
import { useMutation as useMutation2 } from "@tanstack/react-query";
function useDeleteAddressMutation(_ref43) {
  let {
    addressId
  } = _ref43;
  return useMutation2({
    mutationKey: ["deleteAddress", addressId],
    mutationFn: () => __async(null, null, function* () {
      const {
        data
      } = yield AddressHttpClient_default.deleteAddress(addressId);
      return data;
    })
  });
}

// src/library/components/address/AddressDeleteModal.tsx
import { jsx as jsx20, jsxs as jsxs7 } from "react/jsx-runtime";
var AddressDeleteModal = _ref44 => {
  let {
    addressId,
    isModalOpen,
    setIsModalOpen,
    onSuccess
  } = _ref44;
  const intl = useIntl8();
  const queryClient = useQueryClient4();
  const deleteAddressMutation = useDeleteAddressMutation({
    addressId
  });
  return /* @__PURE__ */jsxs7(Modal, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(void 0),
    dismissLabel: "Close",
    size: "sm",
    title: intl.formatMessage({
      id: "address.delete",
      defaultMessage: "Delete address"
    }),
    children: [/* @__PURE__ */jsxs7(Modal.Content, {
      children: [deleteAddressMutation.isError && /* @__PURE__ */jsx20(ErrorAlert_default, {
        sentryException: {
          e: deleteAddressMutation.error,
          tags: {
            fileLocation: "DeleteAddressButton.tsx",
            featureFunction: "deleteAddressMutation"
          },
          fingerPrint: ["address-frontend", "delete-address-button", "delete-address-mutation"]
        }
      }), /* @__PURE__ */jsx20(FormattedMessage11, {
        id: "address.button.deleteAddress.confirmationModal.body",
        defaultMessage: "Are you sure you want to delete this address?"
      })]
    }), /* @__PURE__ */jsxs7(Modal.Footer, {
      className: "pd:flex pd:flex-col pd:gap-2",
      children: [/* @__PURE__ */jsx20(Button4, {
        className: "pd:w-full",
        isLoading: deleteAddressMutation.isPending,
        onClick: () => {
          deleteAddressMutation.mutateAsync().then(() => __async(null, null, function* () {
            setIsModalOpen(void 0);
            if (onSuccess) {
              onSuccess();
            }
            yield queryClient.invalidateQueries({
              queryKey: ["addresses"],
              exact: true
            });
          }));
        },
        children: /* @__PURE__ */jsx20(FormattedMessage11, {
          id: "address.button.deleteAddress.confirmationModal.confirmButton",
          defaultMessage: "Yes, delete"
        })
      }), /* @__PURE__ */jsx20(Button4, {
        className: "pd:w-full",
        variant: "secondary",
        onClick: () => {
          setIsModalOpen(void 0);
        },
        children: /* @__PURE__ */jsx20(FormattedMessage11, {
          id: "address.button.deleteAddress.confirmationModal.cancelButton",
          defaultMessage: "No, cancel"
        })
      })]
    })]
  });
};
var AddressDeleteModal_default = AddressDeleteModal;

// src/library/views/UpdateAddressView.tsx
import { Spinner as Spinner3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage12 } from "react-intl";

// src/library/queries/address/useUpdateAddressMutation.ts
import { useMutation as useMutation3 } from "@tanstack/react-query";
function useUpdateAddressMutation(_ref45) {
  let {
    addressId
  } = _ref45;
  return useMutation3({
    mutationKey: ["updateAddress", addressId],
    mutationFn: payload => __async(null, null, function* () {
      if (!addressId) {
        throw new Error("Cannot update address without addressId");
      }
      const {
        data
      } = yield AddressHttpClient_default.updateAddress(addressId, payload);
      return data;
    })
  });
}

// src/library/views/UpdateAddressView.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var UpdateAddressView = _ref46 => {
  let {
    mutatingAddressId,
    onSubmitSuccess
  } = _ref46;
  const addressQuery = useGetAddressQuery({
    addressId: mutatingAddressId
  });
  const updateAddressMutation = useUpdateAddressMutation({
    addressId: mutatingAddressId
  });
  if (addressQuery.isLoading) {
    return /* @__PURE__ */jsx21("div", {
      className: "pd:flex pd:h-full pd:items-center pd:justify-center",
      children: /* @__PURE__ */jsx21(Spinner3, {})
    });
  }
  if (addressQuery.isError) {
    return /* @__PURE__ */jsx21(ErrorAlert_default, {
      sentryException: {
        e: addressQuery.error,
        tags: {
          fileLocation: "UpdateAddressView.tsx",
          featureFunction: "addressQuery"
        },
        fingerPrint: ["address-frontend", "update-address-view", "address-query"]
      },
      children: /* @__PURE__ */jsx21(FormattedMessage12, {
        id: "address.error.errorWhileLoadingAddresses",
        defaultMessage: "An error occurred while loading your addresses."
      })
    });
  }
  if (addressQuery.data) {
    return /* @__PURE__ */jsx21(AddressFormWrapper_default, {
      defaultValues: {
        firstName: addressQuery.data.address.firstName,
        lastName: addressQuery.data.address.lastName,
        email: addressQuery.data.address.email,
        phone: addressQuery.data.address.phone,
        company: addressQuery.data.address.company,
        vatId: addressQuery.data.address.vatId,
        country: addressQuery.data.address.country,
        postalCode: addressQuery.data.address.postalCode,
        streetNumber: addressQuery.data.address.streetNumber,
        streetName: addressQuery.data.address.streetName,
        city: addressQuery.data.address.city,
        additionalStreetInfo: addressQuery.data.address.additionalStreetInfo,
        defaultBillingAddress: addressQuery.data.isDefaultBillingAddress,
        defaultShippingAddress: addressQuery.data.isDefaultShippingAddress
      },
      onSubmit: _a => __async(null, null, function* () {
        var _b = _a,
          {
            defaultBillingAddress,
            defaultShippingAddress
          } = _b,
          address = __objRest(_b, ["defaultBillingAddress", "defaultShippingAddress"]);
        const data = __spreadValues(__spreadValues({
          address
        }, defaultBillingAddress && {
          setDefaultBillingAddress: true
        }), defaultShippingAddress && {
          setDefaultShippingAddress: true
        });
        yield updateAddressMutation.mutateAsync(data).then(() => {
          onSubmitSuccess(addressQuery.data.address);
        });
      })
    });
  }
  return null;
};
var UpdateAddressView_default = UpdateAddressView;

// src/library/components/address/AddressPanel.tsx
import { Badge, Dropdown, LinkAsButton as LinkAsButton3, Panel as Panel2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage14 } from "react-intl";
import clsx3 from "clsx";

// src/library/components/address/AddressContent.tsx
import { FormattedMessage as FormattedMessage13 } from "react-intl";
import { Fragment as Fragment4, jsx as jsx22, jsxs as jsxs8 } from "react/jsx-runtime";
var AddressContent = _ref47 => {
  let {
    address,
    showFirstAndLastName = false,
    showEmail = false,
    showVatId = false,
    display = "block",
    className
  } = _ref47;
  if (display === "inline") {
    return /* @__PURE__ */jsxs8("div", {
      "data-hj-suppress": true,
      children: [showFirstAndLastName && /* @__PURE__ */jsxs8(Fragment4, {
        children: [address.firstName, " ", address.lastName]
      }), Boolean(address.company) && ", ".concat(address.company), ",", " ", address.streetName, " ", address.streetNumber, Boolean(address.additionalStreetInfo) && ", ".concat(address.additionalStreetInfo), ",", " ", address.postalCode, " ", address.city, ",", " ", address.country in countries_default ? /* @__PURE__ */jsx22(FormattedMessage13, __spreadValues({}, countries_default[address.country])) : address.country, showEmail && Boolean(address.email) && /* @__PURE__ */jsxs8(Fragment4, {
        children: [",", " ", address.email]
      }), showVatId && Boolean(address.vatId) && /* @__PURE__ */jsxs8(Fragment4, {
        children: [",", " ", address.vatId]
      })]
    });
  }
  return /* @__PURE__ */jsxs8("div", {
    className,
    children: [showFirstAndLastName && /* @__PURE__ */jsxs8("p", {
      "data-hj-suppress": true,
      children: [address.firstName, " ", address.lastName]
    }), Boolean(address.company) && /* @__PURE__ */jsx22("p", {
      "data-hj-suppress": true,
      children: address.company
    }), /* @__PURE__ */jsxs8("p", {
      "data-hj-suppress": true,
      children: [address.streetName, " ", address.streetNumber]
    }), Boolean(address.additionalStreetInfo) && /* @__PURE__ */jsx22("p", {
      "data-hj-suppress": true,
      children: address.additionalStreetInfo
    }), /* @__PURE__ */jsxs8("p", {
      "data-hj-suppress": true,
      children: [address.postalCode, " ", address.city]
    }), address.country in countries_default ? /* @__PURE__ */jsx22("p", {
      "data-hj-suppress": true,
      children: /* @__PURE__ */jsx22(FormattedMessage13, __spreadValues({}, countries_default[address.country]))
    }) : /* @__PURE__ */jsx22("p", {
      "data-hj-suppress": true,
      children: address.country
    }), showEmail && Boolean(address.email) && /* @__PURE__ */jsx22("p", {
      "data-hj-suppress": true,
      children: address.email
    }), showVatId && Boolean(address.vatId) && /* @__PURE__ */jsx22("p", {
      children: address.vatId
    })]
  });
};
var AddressContent_default = AddressContent;

// src/library/components/address/AddressDropdownItem.tsx
import { LinkAsButton as LinkAsButton2 } from "@printdeal/ui-library";
import { jsx as jsx23 } from "react/jsx-runtime";
var AddressDropdownItem = _a => {
  var _b = _a,
    {
      title
    } = _b,
    rest = __objRest(_b, ["title"]);
  return /* @__PURE__ */jsx23(LinkAsButton2, __spreadProps(__spreadValues({}, rest), {
    children: title
  }));
};
var AddressDropdownItem_default = AddressDropdownItem;

// src/library/components/address/AddressPanel.tsx
import { Fragment as Fragment5, jsx as jsx24, jsxs as jsxs9 } from "react/jsx-runtime";
import { createElement } from "react";
var AddressPanel = _ref48 => {
  let {
    address,
    isDefaultBillingAddress = false,
    isDefaultShippingAddress = false,
    className,
    dropdownItems = [],
    footer
  } = _ref48;
  return /* @__PURE__ */jsxs9(Panel2, {
    className: clsx3("pd:p-0", className),
    children: [/* @__PURE__ */jsxs9("div", {
      className: "pd:flex pd:flex-col pd:gap-2 pd:p-6",
      children: [/* @__PURE__ */jsxs9("div", {
        className: "pd:flex pd:justify-between",
        children: [/* @__PURE__ */jsxs9("div", {
          className: "pd:flex pd:flex-col-reverse pd:gap-1 pd:md:flex-row pd:md:gap-3",
          children: [/* @__PURE__ */jsxs9("span", {
            className: "pd:font-heading pd:text-lg",
            "data-hj-suppress": true,
            children: [address.firstName, " ", address.lastName]
          }), (isDefaultBillingAddress || isDefaultShippingAddress) && /* @__PURE__ */jsx24(Badge, {
            variant: "info-outline",
            children: isDefaultBillingAddress && isDefaultShippingAddress ? /* @__PURE__ */jsx24(FormattedMessage14, {
              id: "address.badge.defaultBillingAndShippingAddress",
              defaultMessage: "Default billing and shipping address"
            }) : /* @__PURE__ */jsxs9(Fragment5, {
              children: [isDefaultBillingAddress && /* @__PURE__ */jsx24(FormattedMessage14, {
                id: "address.defaultBilling",
                defaultMessage: "Default billing address"
              }), isDefaultShippingAddress && /* @__PURE__ */jsx24(FormattedMessage14, {
                id: "address.defaultShipping",
                defaultMessage: "Default shipping address"
              })]
            })
          })]
        }), Boolean(dropdownItems.length > 0) && /* @__PURE__ */jsxs9(Dropdown, {
          children: [/* @__PURE__ */jsx24(Dropdown.Button, {
            as: LinkAsButton3,
            variant: "secondary",
            label: /* @__PURE__ */jsx24(FormattedMessage14, {
              id: "address.dropdown.label",
              defaultMessage: "More actions"
            }),
            iconAfter: "more"
          }), /* @__PURE__ */jsx24(Dropdown.Panel, {
            className: "pd:absolute pd:right-0 pd:whitespace-nowrap",
            children: /* @__PURE__ */jsx24("div", {
              className: "pd:flex pd:flex-col pd:gap-4",
              children: dropdownItems.map(item => /* @__PURE__ */createElement(AddressDropdownItem_default, __spreadProps(__spreadValues({
                variant: "secondary"
              }, item), {
                key: item.title
              })))
            })
          })]
        })]
      }), /* @__PURE__ */jsx24(AddressContent_default, {
        address,
        showEmail: true,
        className: "pd:text-sm"
      })]
    }), /* @__PURE__ */jsx24("div", {
      className: "pd:flex pd:justify-end pd:gap-4 pd:rounded-b-md pd:border-t-1 pd:px-6 pd:py-4",
      children: footer
    })]
  }, address.id);
};
var AddressPanel_default = AddressPanel;
export { AddressContent_default as AddressContent, AddressDeleteModal_default as AddressDeleteModal, AddressFormSubmitButton_default as AddressFormSubmitButton, AddressListView_default as AddressListView, AddressPanel_default as AddressPanel, AddressValidationMessage_default as AddressValidationMessage, CreateAddressView_default as CreateAddressView, UpdateAddressView_default as UpdateAddressView, additionalStreetInfoSchema, addressLineSchema, addressSchema, citySchema, companySchema, countries_default as countries, countrySchema, emailSchema, firstNameSchema, lastNameSchema, phoneSchema, postalCodeSchema, splitStreetNumberAndAddition, streetNameSchema, streetNumberSchema, useGetAddressQuery, useGetAddressesQuery, usePrefetchAddresses, useTranslatedAddressYupErrorMessage, vatIdSchema };